const carouselContExists = document.querySelectorAll(`.carousel`);
if (carouselContExists) {
  carouselContExists.forEach((carousel) => {
    // Globals
    let slide = 0;
    const slides = carousel.querySelectorAll(`.carousel-card`);
    let numSlides = slides.length;

    function setInitial() {
      createBlogNavDots();
      currentSlide();
      createNavDotEvent();
      setInitProgress();
    }

    /**
     * Sets the current slide and restarts the interval if a new slide
     * is activated.
     */
    function currentSlide() {
      let itemtoShow = Math.abs(slide % numSlides);
      let currentDot = carousel.querySelectorAll(`.nav-dot`);
      let nextSlide = (slide + 1) % currentDot.length;
      currentDot.forEach(function (item, index) {
        slides[index].classList.remove(`active`);
        slides[index].classList.remove(`next`);
        currentDot[index].classList.remove(`active`);
      });
      slides[itemtoShow].classList.add(`active`);
      slides[nextSlide].classList.add(`next`);
      currentDot[itemtoShow].classList.add(`active`);
      resetInterval();
    }

    /**
     * Creates the navigation dots for the blog page section
     */
    function createBlogNavDots() {
      for (i = 0; i < numSlides; i++) {
        let dotDiv = document.createElement(`div`);
        let dotNavContainer = carousel.querySelector(`.carousel-nav-dots`);
        dotDiv.classList.add(`nav-dot`);
        dotDiv.classList.add(`dot-` + i);
        dotNavContainer.appendChild(dotDiv);
      }
    }

    function next() {
      slide++;
      currentSlide();
    }

    function prev() {
      slide--;
      currentSlide();
    }

    function setInitProgress() {
      let setProgress = carousel.querySelector(".timer");
      setProgress.classList.add("progress-bar");
    }

    function resetProgress() {
      let elm = carousel.querySelector(".progress-bar");
      let newone = elm.cloneNode(true);
      elm.parentNode.replaceChild(newone, elm);
    }

    // function resetSlide() {
    //   var elm = document.querySelector(`.nav-dot`),
    //     newone = elm.cloneNode(true),
    //     x = elm.parentNode.replaceChild(newone, elm);
    // }

    function resetInterval() {
      clearInterval(autonext);
      autonext = setInterval(function () {
        next();
      }, 10000);
      resetProgress();
    }

    let autonext = setInterval(function () {
      next();
    }, 10000);

    function createNavDotEvent() {
      carousel.querySelectorAll(`.nav-dot`).forEach(function (item, index) {
        item.addEventListener(`click`, function () {
          slide = index;
          currentSlide();
          resetProgress();
        });
      });
    }

    setInitial();
  });
}
